
import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('FORUMS_STATS').plugin(axiosPlugin);

let fetchAction = redux.fetchActionGetOne();

export const TYPES = redux.types;

export const fetchForumsStats = () => fetchAction(`/forums/stats`);
export const resetForumsStats = () => redux.actions.reset();

export const forumsStats = redux.reducer();